import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/lang";

const KEY = "beintec-cookie-consent";

const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const id = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(id);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
    if (value === "accepted") {
      window.dispatchEvent(new Event("beintec-consent"));
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 60, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 40, scale: 0.97 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-4 bottom-4 z-[60] sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md"
        >
          <div className="rounded-2xl border border-white/10 bg-bei-navy/95 p-6 shadow-[0_24px_60px_rgba(11,25,44,0.45)] backdrop-blur-xl">
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-bei-brand/25 text-bei-cyan">
                <Cookie className="h-5 w-5" />
              </span>
              <div>
                <p className="font-display text-base font-bold text-white">{t.cookies.title}</p>
                <p className="mt-1.5 text-xs leading-relaxed text-slate-300 sm:text-sm">
                  {t.cookies.text}{" "}
                  <Link
                    to="/politique-confidentialite"
                    data-testid="cookie-privacy-link"
                    onClick={() => setVisible(false)}
                    className="font-semibold text-bei-cyan underline-offset-2 transition-colors hover:underline"
                  >
                    {t.cookies.more}
                  </Link>
                </p>
              </div>
            </div>
            <div className="mt-5 flex gap-3">
              <button
                data-testid="cookie-accept-button"
                onClick={() => choose("accepted")}
                className="flex-1 rounded-full bg-bei-brand px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-bei-azure"
              >
                {t.cookies.accept}
              </button>
              <button
                data-testid="cookie-refuse-button"
                onClick={() => choose("refused")}
                className="flex-1 rounded-full border border-white/25 px-5 py-2.5 text-sm font-semibold text-slate-200 transition-all duration-300 hover:border-bei-cyan hover:text-bei-cyan"
              >
                {t.cookies.refuse}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
